import { post } from '@/services/index';
export const login = params => {
  return post({
    url: '/login',
    data: {
      username: params.username,
      password: params.password
    }
  });
};